import { Vue } from "@/public/utils/customVue";

let $edApi = Vue.prototype.$edApi;
export default {
    state: {
        edViewLibrarys: [],
        menuList: [],
        checkbox: {},
        extraDB: ["userDB", "openDB", "myDB"],
        collectTBID: 149999,
        collectTBSymbolKey: "",
        collectTBEdtKey: "", // 用于发布符号模板
        uploadTimer: 0,
        ossList: [],
        contextLocker: false,
        displayList: [
            // {
            //     groupName: 'flowchart',
            //     children: [
            //         {
            //             tableName: 'container',
            //             showList: [
            //                 {
            //                     img: '',
            //                     name: '',
            //                 }
            //             ]
            //         }
            //     ]
            // }
        ],
        libraryDisplayList: {},
        libPage: "publicLib",
        dragData: null,
        viewDragFlag: false,
        vueDragFlag: false,
        dragSymbolToPage: false,
        selectLibraryTitlePos: [0, 0],
        showImportModal: false,
        showEditModal: false,
        editLibrary: {},
        mutiSelect: false,
        customLibraryPath: "",
        symbolCount: 0,
        libraryError: false,
        myLibraryData: [],
        publicLibraryData: [],
        libraryType: "publicLibrary",
        libraryModelMenuList: [],
        librartModelBackUpMenuList: [],
        trackedLibraryIds: [],
    },
    mutations: {
        setLibraryState(state, obj) {
            Vue.set(state, obj.type, obj.data);
        },
        setLibraryDisplayList(state, obj) {
            let db = obj.groupName;
            let tb = obj.tableName;
            let list = state.displayList;

            for (let i = 0; i < list.length; i++) {
                if (list[i].groupName == db) {
                    for (let j = 0; j < list[i].children.length; j++) {
                        if (list[i].children[j].tableName == tb) {
                            list[i].children[j].showList = null;
                            list[i].children[j].showList = obj.data;
                            break;
                        }
                    }
                    break;
                }
            }
        },
        cleanLibraryDisplayList(state) {
            let list = state.displayList;
            for (let i = 0; i < list.length; i++) {
                for (let j = 0; j < list[i].children.length; j++) {
                    list[i].children[j].showList = [];
                }
            }
        },

        setNewLibraryDisplayList(state, obj) {
            let list = state.libraryDisplayList;

            let { groupName, data, clearOld } = obj;
            let old = list[groupName] || {
                data: [],
                groupName,
            };
            old.data.push(...data);
            if (clearOld) {
                old = {
                    data: [],
                    groupName,
                };
            }
            Vue.set(list, groupName, old);
            state.libraryDisplayList = list;
        },
        cleanNewLibraryDisplayList(state) {
            state.libraryDisplayList = {};
        },
    },
    actions: {
        upLoadLibrary(state, data) {
            return new Promise((resolve, reject) => {
                $edApi
                    .uploadCustomLibrary(data)
                    .then((res) => {
                        let list = [];
                        let ossParams = {
                            //edt
                            url: res.data.edt.obj,
                            exp: res.data.exp,
                            sign: res.data.edt.sign,
                            file: data.files[0].file,
                            contentType: "application/octet-stream",
                        };
                        let ossParams2 = {
                            // edl
                            url: res.data.edl.obj,
                            exp: res.data.exp,
                            sign: res.data.edl.sign,
                            file: data.files[1].file,
                            contentType: "application/octet-stream",
                        };
                        list.push($edApi.uploadOSSFile(ossParams));
                        list.push($edApi.uploadOSSFile(ossParams2));
                        Promise.all(list).then((e) => {
                            resolve(res);
                        });
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
    },
};
